import { render, staticRenderFns } from "./EconomicEditor.vue?vue&type=template&id=539c4ac0"
import script from "./EconomicEditor.vue?vue&type=script&lang=js"
export * from "./EconomicEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports